declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

// Web → RN (postMessage type)
export const WEB_TO_APP = {
  WEBVIEW_READY: 'WEBVIEW_READY',
  // 앱 메타데이터(플랫폼/버전/모델) 요청 — 앱 1.0.21부터 응답
  CHECK_APPLICATION_METADATA: 'CHECK_APPLICATION_METADATA',
  FETCH_PURCHASE_OFFERING: 'FETCH_PURCHASE_OFFERING',
  FETCH_PURCHASE_STATUS: 'FETCH_PURCHASE_STATUS',
  EXECUTE_PURCHASE: 'EXECUTE_PURCHASE',
  RESTORE_PURCHASE: 'RESTORE_PURCHASE',
  // 공통 사진 촬영·선택·업로드
  SAVE_FILE: 'SAVE_FILE',
  OPEN_DOWNLOAD: 'OPEN_DOWNLOAD',
  TAKE_PHOTO: 'TAKE_PHOTO',
  SELECT_PHOTO: 'SELECT_PHOTO',
  UPLOAD_PHOTO: 'UPLOAD_PHOTO',
  REMOVE_PHOTO: 'REMOVE_PHOTO',
  // AI 말하기 녹음
  START_AUDIO_RECORDING: 'START_AUDIO_RECORDING',
  FINISH_AUDIO_RECORDING: 'FINISH_AUDIO_RECORDING',
  CANCEL_AUDIO_RECORDING: 'CANCEL_AUDIO_RECORDING',
  // 녹음 종료 후 웹이 presigned URL을 받아 와 업로드를 요청한다
  UPLOAD_AUDIO_RECORDING: 'UPLOAD_AUDIO_RECORDING',
  // 학습 화면 진입 시 마이크 권한 확인(필요하면 요청)
  CHECK_MICROPHONE_PERMISSION: 'CHECK_MICROPHONE_PERMISSION',
  // blocked 상태에서 OS 설정 앱 열기
  OPEN_SYSTEM_SETTING: 'OPEN_SYSTEM_SETTING',
} as const;

// RN → Web (CustomEvent name)
export const APP_TO_WEB = {
  PUSH_TOKEN: 'PUSH_TOKEN',
  APPLICATION_METADATA: 'APPLICATION_METADATA',
  PURCHASE_OFFERING: 'PURCHASE_OFFERING',
  EXECUTE_PURCHASE_RESULT: 'EXECUTE_PURCHASE_RESULT',
  RESTORE_PURCHASE_RESULT: 'RESTORE_PURCHASE_RESULT',
  PURCHASE_STATUS: 'PURCHASE_STATUS',
  SAVE_FILE_RESULT: 'SAVE_FILE_RESULT',
  OPEN_DOWNLOAD_RESULT: 'OPEN_DOWNLOAD_RESULT',
  TAKE_PHOTO_RESULT: 'TAKE_PHOTO_RESULT',
  SELECT_PHOTO_RESULT: 'SELECT_PHOTO_RESULT',
  UPLOAD_PHOTO_RESULT: 'UPLOAD_PHOTO_RESULT',
  REMOVE_PHOTO_RESULT: 'REMOVE_PHOTO_RESULT',
  // AI 말하기 녹음
  AUDIO_RECORDING_STATUS: 'AUDIO_RECORDING_STATUS',
  FINISH_AUDIO_RECORDING_RESULT: 'FINISH_AUDIO_RECORDING_RESULT',
  UPLOAD_AUDIO_RECORDING_RESULT: 'UPLOAD_AUDIO_RECORDING_RESULT',
} as const;

// Web → RN 메시지 전송
export const sendApplicationEventByBridge = (type: string, data?: any) => {
  window.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
};

// RN → Web 이벤트 수신 (Promise 기반)
export const receiveApplicationEventByBridge = <T>(eventName: string, timeout = 30000): Promise<T> => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener(eventName, handler as EventListener);
      reject(new Error(`${eventName} timeout`));
    }, timeout);

    const handler = (e: CustomEvent<T>) => {
      clearTimeout(timer);
      window.removeEventListener(eventName, handler as EventListener);
      resolve(e.detail);
    };

    window.addEventListener(eventName, handler as unknown as EventListener);
  });
};
